"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerDefaultTypes = registerDefaultTypes;

var _RuleEditorSelect = _interopRequireWildcard(require("./atoms/RuleEditorSelect"));

var _RuleEditorLabel = _interopRequireDefault(require("./atoms/RuleEditorLabel"));

var _RuleEditorDate = _interopRequireWildcard(require("./atoms/RuleEditorDate"));

var _RuleEditorText = _interopRequireDefault(require("./atoms/RuleEditorText"));

var _RuleEditorNumber = _interopRequireWildcard(require("./atoms/RuleEditorNumber"));

var _RuleEditorCheckbox = _interopRequireWildcard(require("./atoms/RuleEditorCheckbox"));

var _utils = require("./utils");

function registerDefaultTypes() {
  (0, _utils.registerType)({
    type: "label",
    Component: _RuleEditorLabel.default
  });
  (0, _utils.registerType)({
    type: "date",
    Component: _RuleEditorDate.default,
    validator: _RuleEditorDate.isValidDateValue
  });
  (0, _utils.registerType)({
    type: "text",
    Component: _RuleEditorText.default
  });
  (0, _utils.registerType)({
    type: "number",
    Component: _RuleEditorNumber.default,
    validator: _RuleEditorNumber.isValidNumberValue
  });
  (0, _utils.registerType)({
    type: "checkbox",
    Component: _RuleEditorCheckbox.default,
    validator: _RuleEditorCheckbox.isValidCheckboxValue
  });
  (0, _utils.registerType)({
    type: "select",
    Component: _RuleEditorSelect.default,
    nextAtom: _RuleEditorSelect.getNextSelectAtom,
    subRule: _RuleEditorSelect.getSelectAtomSubRuleId,
    validator: _RuleEditorSelect.isValidSelectValue
  });
}